<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	interface ICellChildrenData {
		_key: string;
		_type: string;
		marks: any[];
		text: string;
	}

	export let portableText: CustomBlockComponentProps<{
		global: any[];
		value: {
			_key: string;
			_type: string;
			rows: any[];
		};
		indexInParent: number;
		isInline: boolean;
	}>;

	$: dark = portableText?.global?.context?.dark;

	function getString(arr: ICellChildrenData[]) {
		if (!arr) return '';
		return arr.map((i) => i.text).join('');
	}
</script>

<div class="wrapper" class:dark>
	{#if portableText}
		<div class="table">
			{#each portableText?.value?.rows as row, i}
				<div class:border={i === 0}>
					<div class="row" class:head-row={i === 0}>
						{#each row.cells as cell}
							<div class="body-cell">{getString(cell?.data?.contents[0]?.children)}</div>
						{/each}
					</div>
				</div>
			{/each}
		</div>
	{/if}
</div>
<br />

<style lang="scss">
	@import 'sanityTable';
</style>
